import React from "react";
import { FiZap } from "react-icons/fi";
import MiniGamePage from "./MiniGamePage";
import { boomCardsApi } from "../../utils/miniGameApi";

const BoomCardsGame = () => (
  <MiniGamePage
    title="Boom Cards Game"
    selfLabel="Boom Cards"
    description="Manage Boom Cards game rules, reward range, timer, and play audit logs."
    icon={FiZap}
    api={boomCardsApi}
    scoreLabel="Score / Flips"
    switchTo={[
      { to: "/tap-game", label: "Tap Game" },
      { to: "/game-2048", label: "2048" },
    ]}
  />
);

export default BoomCardsGame;
